import PaymentSchedulesPage from "../../pages/legacy/paymentSchedules/PaymentSchedulesPage";

const route = {
  key: "paymentSchedules",
  path: "/legacy/payment-schedules",
  component: PaymentSchedulesPage,
  private: true,
  layout: "main",
  icon: "faTable",
  group: "configuration",
  order: 80,
  permission: "legacy.paymentSchedules.read"
};

export default route;